import { withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { IProvideCssDefinition } from '@wix/site-service-provide-css/definition'
import { ProvideCssDefinition as definition } from '@wix/site-service-provide-css/definition'
import { ProvideCssService as impl } from '@wix/site-service-provide-css/implementations'

export const siteProvideCssService: FactoryWithDependencies<ServiceProvider<IProvideCssDefinition, typeof impl>> =
	withDependencies([], (): ServiceProvider<IProvideCssDefinition, typeof impl> => {
		return {
			definition,
			impl,
			config: {},
		}
	})
